import { Injectable } from '@angular/core';
import {
  ICONE_PADRAO_SIDEBAR,
  normalizarChave,
  resolverIconeModulo,
} from '../config/modulos-sidebar.config';

export type ResultadoModuloSidebar = {
  chaveResolvida: string;
  iconName: string;
};

@Injectable({ providedIn: 'root' })
export class ResolverModuloSidebarService {
  resolver(modulo: any): ResultadoModuloSidebar {
    const chave =
      normalizarChave(this.stripSlashes(modulo?.caminho_exibicao)) ||
      normalizarChave(modulo?.nome) ||
      'padrao';

    const iconName = resolverIconeModulo(modulo);

    return {
      chaveResolvida: chave,
      iconName: iconName || ICONE_PADRAO_SIDEBAR,
    };
  }

  private stripSlashes(v: any): string {
    if (v === null || v === undefined) return '';
    return String(v)
      .trim()
      .replace(/^\/+|\/+$/g, '');
  }
}
